import React from "react";

import showSecondarySidebar from "../../components/Layout/helpers/showSecondarySidebar";

import GoogleMapsComponent from "../../components/Map/GoogleMapsComponent";
import GoogleMapsComponentEvent from "../../components/Map/GoogleMapsComponentEvent";
import GoogleMapsComponentAddPOI from "../../components/Map/GoogleMapsComponentAddPOI";
import GoogleMapsComponentEditPOI from "../../components/Map/GoogleMapsComponentEditPOI";
import GoogleMapsComponentGeofence from "../../components/Map/GoogleMapsComponentGeofence";
import GoogleMapsComponentAddPolygon from "../../components/Map/GoogleMapsComponentAddPolygon";
import GoogleMapsComponentTripRecord from '../../components/Map/GoogleMapsComponentTripRecord';
import GoogleMapsComponentEditPolygon from "../../components/Map/GoogleMapsComponentEditPolygon";

const MainPanel = (props) => {
  const renderMap = pathname => {
    switch (pathname) {

      case '/TripRecord':
        return <GoogleMapsComponentTripRecord />

      case '/Geofence':
        return <GoogleMapsComponentGeofence />

      case '/Geofence/AddNewPOI':
        return <GoogleMapsComponentAddPOI />

      case '/Geofence/EditPOI':
        return <GoogleMapsComponentEditPOI />

      case '/Geofence/AddNewZone':
        return <GoogleMapsComponentAddPolygon />

      case '/Geofence/EditZone':
        return <GoogleMapsComponentEditPolygon />

      case "/EventRecord":
        return <GoogleMapsComponentEvent />

      default:
        return <GoogleMapsComponent />
    }
  }

  return (
    <div>{renderMap(props.location.pathname)}</div>
  );
}
export default showSecondarySidebar(true)(MainPanel);
